/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const AgeGroup = {
    Unknown: 'Unknown',
    Schooling: 'Schooling',
    Adult: 'Adult',
    BestAger: 'BestAger'
} as const;
export type AgeGroup = typeof AgeGroup[keyof typeof AgeGroup];


export function instanceOfAgeGroup(value: any): boolean {
    for (const key in AgeGroup) {
        if (Object.prototype.hasOwnProperty.call(AgeGroup, key)) {
            if (AgeGroup[key as keyof typeof AgeGroup] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AgeGroupFromJSON(json: any): AgeGroup {
    return AgeGroupFromJSONTyped(json, false);
}

export function AgeGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgeGroup {
    return json as AgeGroup;
}

export function AgeGroupToJSON(value?: AgeGroup | null): any {
    return value as any;
}

export function AgeGroupToJSONTyped(value: any, ignoreDiscriminator: boolean): AgeGroup {
    return value as AgeGroup;
}

